import { compose } from 'recompose';

import CategoriesFilter from './CategoriesFilter';

const enhance = compose();

export default enhance(CategoriesFilter);
